import * as React from "react";
// import { RefreshControls, DashboardTemplates, ConnectionStatus, ModernTaskpane } from "../dashboard/DashboardControls";
// import { useAppController } from "../../hooks/useAppController";
// import { Spinner, Text } from "@fluentui/react-components";

import { WelcomeMessage, ModernTaskpane } from "../dashboard/DashboardControls";
// import { useAppController } from "../../hooks/useAppController";
// import { Spinner, Text } from "@fluentui/react-components";

const DashboardRoute: React.FC = () => {
  // const controller = useAppController();

  return (
    <ModernTaskpane>
      <WelcomeMessage />
      {/* <DashboardTemplates
        isGeneratingDashboard={controller.isGeneratingDashboard}
        activeDashboard={controller.activeDashboard}
        onGenerate={controller.handleGenerateDashboard}
      />
      <ConnectionStatus isGeneratingDashboard={controller.isGeneratingDashboard} />
      <RefreshControls
        onRefresh={controller.handleRefreshData}
        isRefreshing={controller.isRefreshing}
        isGeneratingDashboard={controller.isGeneratingDashboard}
        lastUpdated={controller.lastUpdated}
        buttonText={(() => {
          switch (controller.activeDashboard) {
            case "Inventory Dashboard":
              return "Refresh Inventory Data";
            case "Sales Performance Dashboard":
              return "Refresh Sales Data";
            case "Marketing Dashboard":
              return "Refresh Marketing Data";
            case "Raw Data":
              return "Refresh Data Sheet";
            default:
              return "Refresh Data";
          }
        })()}
      /> */}

      {/* {controller.isGeneratingDashboard && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 16,
            padding: "24px",
            background:
              "linear-gradient(180deg, rgba(211,232,217,0.95) 0%, rgba(238,238,238,0.95) 79.45%)",
            backdropFilter: "blur(6px)",
            zIndex: 1000,
          }}
        >
          <Spinner size="extra-large" />
          <div style={{ textAlign: "center" }}>
            <Text size={500} weight="semibold" style={{ color: "#0F172A" }}>
              Generating Dashboard
            </Text>
            <div style={{ height: 6 }} />
            <Text size={300} style={{ color: "#667085" }}>
              {(() => {
                const name =
                  controller.activeDashboard === "Sales Performance Dashboard"
                    ? "Sales Dashboard"
                    : controller.activeDashboard === "Marketing Dashboard"
                    ? "Advertising Dashboard"
                    : controller.activeDashboard || "Dashboard";
                return `Please wait while we create your ${name}`;
              })()}
            </Text>
          </div>
        </div>
      )} */}
    </ModernTaskpane>
  );
};

export default DashboardRoute;
